// Cookie management utilities

/**
 * Set a cookie
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} days - Days until expiration
 */
export function setCookie(name, value, days = 365) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
}

/**
 * Get a cookie value
 * @param {string} name - Cookie name
 * @returns {string|null} Cookie value or null if not found
 */
export function getCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  
  return null;
}

/**
 * Delete a cookie
 * @param {string} name - Cookie name
 */
export function deleteCookie(name) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}

/**
 * Check if user has accepted cookies
 * @returns {boolean}
 */
export function hasAcceptedCookies() {
  return getCookie('cookieConsent') === 'accepted';
}

/**
 * Accept cookies
 */
export function acceptCookies() {
  setCookie('cookieConsent', 'accepted', 365);
}

/**
 * Decline cookies
 */
export function declineCookies() {
  setCookie('cookieConsent', 'declined', 365);
}

/**
 * Get cookie preferences
 * @returns {object} Cookie preferences
 */
export function getCookiePreferences() {
  const prefs = getCookie('cookiePreferences');
  if (!prefs) {
    return {
      necessary: true,
      analytics: false,
      marketing: false
    };
  }
  
  try {
    return JSON.parse(prefs);
  } catch {
    return {
      necessary: true,
      analytics: false,
      marketing: false
    };
  }
}

/**
 * Save cookie preferences
 * @param {object} preferences - Cookie preferences
 */
export function saveCookiePreferences(preferences) {
  setCookie('cookiePreferences', JSON.stringify(preferences), 365);
  setCookie('cookieConsent', 'accepted', 365);
}
